module.exports = __webpack_public_path__ + "img/dragon_rune.14ec9fcb.png";